import { connect } from 'react-redux';
import { useEffect } from 'react';
import {
    Dropdown,
    Field,
    Option,
    OptionOnSelectData,
    SelectionEvents
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

// component functions
import * as ComponentFunctions from './LanguajeSelector.Functions';

const LanguageSelectorComponent = (props: ComponentFunctions.Props) => {

    const { t, i18n } = useTranslation();

    useEffect(() => {
        props.GetAllLanguajes();
    }, []);

    const onChangeLanguaje = (_event: SelectionEvents, data: OptionOnSelectData) => {
        const selectedLanguaje = props.Languajes?.find(x => x.code === data.optionValue);
        if (!selectedLanguaje) return;

        // Se cambia el idioma en el acto ademas de despacharlo al store: dejarlo
        // solo en redux hacia depender el cambio de un efecto en App, y si ese
        // efecto no corria (o el valor no cambiaba de referencia) la pantalla
        // seguia en el idioma anterior.
        i18n.changeLanguage(selectedLanguaje.code);
        props.SetUserLanguaje(selectedLanguaje);
    };

    // Controlado, no valor por defecto: con `defaultSelectedKey` el selector se
    // quedaba con la primera clave que veia y no reflejaba el idioma real cuando
    // este se resolvia despues (token, preferencia guardada).
    const selectedCode = props.currentLanguaje?.code || i18n.language || 'es';
    const selectedText =
        props.Languajes?.find(x => x.code === selectedCode)?.description ?? '';

    return (
        <Field label={t('languageSelector.label')}>
            <Dropdown
                placeholder={t('languageSelector.placeholder')}
                // Dropdown v9 se controla con el par valor visible / opciones
                // seleccionadas; `value` es lo que se lee en la caja cerrada.
                value={selectedText}
                selectedOptions={[selectedCode]}
                onOptionSelect={onChangeLanguaje}
            >
                {(props.Languajes || []).map((languaje) => (
                    <Option key={languaje.code} value={languaje.code} text={languaje.description}>
                        {languaje.description}
                    </Option>
                ))}
            </Dropdown>
        </Field>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(LanguageSelectorComponent as any);
